import React from 'react'

type SkeletonBarProps = {
  width?: number | string
  height?: number
  pill?: boolean
}

export const SkeletonBar: React.FC<SkeletonBarProps> = ({
  width,
  height,
  pill,
}) => (
  <span
    className="sp-history-skeleton-bar"
    style={{
      width,
      height,
      borderRadius: pill && height ? height / 2 : undefined,
    }}
  />
)

export const SkeletonList: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="sp-history-skeleton" aria-hidden="true">
    {children}
  </div>
)

export const SkeletonCard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="sp-history-skeleton-card">{children}</div>

export const SkeletonRow: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="sp-history-skeleton-row">{children}</div>

export const SkeletonMonthRow: React.FC<{ width?: number | string }> = ({
  width = 72,
}) => (
  <div className="sp-history-skeleton-month">
    <SkeletonBar width={width} />
  </div>
)
